import * as React from 'react';

export const InputLabel = ({ error, className, children, ...props } : any) => {
    return (
        <label className={'label ' + props.className} {...props}>
            {children}
        </label>
    );
};
